module.exports = {
    FILE_NUMBER_LIMIT: 10,
    FILE_SIZE_LIMIT: 3500,
    FILE_TYPES: ['pdf', 'jpeg', 'png'],
    FILE_DISCRIPTION_CHARS_LIMIT: 100,
    FILE_NAME_CHARS_LIMIT: 40,
    FILE_NAME_REGEX: /^[a-z0-9| |_|á|é|í|ó|ú|ñ|ä|ë|ï|ö|ü|ç]+\.[a-z0-9]{3,4}$/ig,
    ACCOUNT_DIRECT_DEBIT_DOWNLOAD_DEBIT_FORMAT_PDF_URL: 'https://www.openbank.es/assets/static/pdf/PieDePagina/Solicitud_Domiciliacion_Recibos.pdf',
    ACCOUNT_DIRECT_DEBIT_EMAILID:'domiciliaciones@openbank.es',
}
